import { NotFoundContainer } from './style'
import { IoIosAlert } from "react-icons/io";

const NotFound = () => {
  return (
    <NotFoundContainer>
      <IoIosAlert size={48} color='#6E8398' />
      <h1>Nenhum dado encontrado</h1>
      <span>Informe obrigatoriamente na busca para qual serviço será o relatório</span>
    </NotFoundContainer>
  )
}

export default NotFound
